import { render, staticRenderFns } from "./SafetySettingsIndex.vue?vue&type=template&id=fcb507d0"
import script from "./SafetySettingsIndex.vue?vue&type=script&lang=js"
export * from "./SafetySettingsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports